import React from "react";
import PropTypes from "prop-types";
require("./style.css");

export default class ToggleButton extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  _handleKeyDown(event) {
    event.key == "Enter" ? this.props.onClick(event) : "";
  }

  render() {
    let { id, label, checked, onClick } = this.props;

    return (
      <label
        {...(id && id != "" && { id: id, htmlFor: id })}
        className={`toggleButton ${checked ? "is-checked" : ""} `}
        role="button"
        title={label}
        tabIndex="0"
        onKeyPress={(event) => this._handleKeyDown(event)}
      >
        <span onClick={onClick}>{label}</span>
        <input
          style={{ display: "none" }}
          type="checkbox"
          checked={checked}
          value={checked}
        />
      </label>
    );
  }
}

ToggleButton.defaultProps = {
  label: "",
  id: "",
  checked: false,
  style: {},
  onClick: () => {},
};
